import { useState } from "react";
import { Card, Image } from "react-bootstrap";
import { BsHeartFill } from "react-icons/bs";
import classNames from "classnames";
import { SkinModel } from "../../../features/skin/skinTypes";
import { useVoteForSkin } from "../../../features/skin/skinApi";

type Props = {
    skin: SkinModel;
    size: "sm" | "lg" | "md";
    isTopSkin: boolean;
};

const SkinVoteItem = ({ size, skin, isTopSkin }: Props) => {
    const [votes, setVotes] = useState(skin.votes);
    const [isAnimating, setIsAnimating] = useState(false);
    const { mutate:voteForSkin } = useVoteForSkin();

    const handleVoteClick = async () => {
        setIsAnimating(true);

        voteForSkin(skin.id);
        setVotes(votes+1);
    };

    const svgClassName = classNames("heart-icon", {
        "animate__animated animate__bounceIn": isAnimating,
    });

    return (
        <Card className={`skin-card ${size} ${isTopSkin && "top-skin"}`}>
            <Card.Img variant="top" as={Image} src={skin.car_image} alt={skin.name} />
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center w-100">
                    <p className="text-uppercase mb-0 flex-grow-1">{skin.name}</p>
                    <button className="btn btn-link" onClick={handleVoteClick}>
                        <span className={'me-1'}>{votes}</span>
                        <BsHeartFill className={svgClassName} />
                    </button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default SkinVoteItem;
